import React from "react"
import { graphql } from "gatsby"
import { Seo } from "../../components"
import { Container } from "@chakra-ui/react"

import Header from "./Header"
import Body from "./Body"
import Pagination from "./Pagination"

export const blogPostQuery = graphql`
  query($id: String!, $previousPostId: String, $nextPostId: String) {
    current: mdx(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        tag
        date(formatString: "MMMM DD, YYYY")
        description
        image {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
    previous: mdx(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: mdx(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`

export default function BlogPost({ data }) {
  const { current, previous, next } = data
  const { title, date, description, tag, image } = current.frontmatter

  const seoProps = {
    title: title,
    description: description || current.excerpt,
  }

  const headerProps = {
    title,
    image,
    tag,
  }

  const bodyProps = {
    current,
    date,
    tag,
  }

  const paginationProps = {
    previous,
    next,
  }

  return (
    <React.Fragment>
      <Seo {...seoProps} />
      <Container maxW="960px">
        <Header {...headerProps} />
        <Body {...bodyProps} />
        <Pagination {...paginationProps} />
      </Container>
    </React.Fragment>
  )
}
